export function windowSizes() {
	var ww = $(window).width();
	var wh = $(window).height();
	var orientation = ww > wh ? "landscape" : "portrait";
	var isMobileSize =
		(ww <= 900 && orientation === "landscape") ||
		(ww <= 767 && orientation === "portrait");
	var isTabletSize =
		!isMobileSize &&
		((ww <= 1024 && orientation === "landscape") ||
			(ww <= 900 && orientation === "portrait"));

	return {
		width: ww,
		height: wh,
		orientation: orientation,
		isMobile: isMobileSize,
		isTablet: isTabletSize,
		isDesktop: !isMobileSize && !isTabletSize,
	};
}

export function getElementOffset($elem) {
	const offset = $elem.offset();
	offset.width = Math.round($elem.width());
	offset.height = Math.round($elem.height());
	offset.right = Math.round(offset.left + offset.width);
	offset.bottom = Math.round(offset.top + offset.height);
	offset.centerx = Math.round(offset.left + (offset.width / 2));
	offset.centery = Math.round(offset.top + (offset.height / 2));
	return offset;
}

export function getPageOffset() {
	var page = $(document.documentElement);
	var pOffset = page.offset();
	pOffset.width = page.width();
	pOffset.height = page.height();
	pOffset.right = pOffset.left + pOffset.width;
	pOffset.bottom = pOffset.top + pOffset.height;
	pOffset.scrollLeft = page[0].scrollLeft;
	pOffset.scrollTop = page[0].scrollTop;
	return pOffset
}
